<template>
  <div class="user-avator-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge>
        <Avatar :style="{background:'#00cc66'}" :src="userAvator"/>
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <!--<DropdownItem name="logout">消息中心</DropdownItem>-->
        <DropdownItem name="tenantName" disabled>{{ tenantInfo.name }}</DropdownItem>
        <DropdownItem name="refreshCache">{{ langMap.refreshCache[lang] }}</DropdownItem>
        <DropdownItem name="updatePwd">{{ langMap.updatePwd[lang] }}</DropdownItem>
        <DropdownItem name="logout">{{ langMap.logout[lang] }}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Modal
      v-model="updatePwdModel"
      :title="langMap.updateLoginPwd[lang]">
      <Form
        ref="updatePwdForm" :model="updatePwdForm" :label-width="100" label-position="right" :rules="passwordValidate">
        <FormItem :label="langMap.oldPwd[lang]" prop="oldPwd">
          <Input v-model="updatePwdForm.oldPwd" type="password" :placeholder="langMap.inputCurrentPwd[lang]" ></Input>
        </FormItem>
        <FormItem :label="langMap.newPwd[lang]" prop="newPwd">
          <Input v-model="updatePwdForm.newPwd" type="password" :placeholder="langMap.inputNewPwd[lang]" ></Input>
        </FormItem>
        <FormItem :label="langMap.confirmNewPwd[lang]" prop="rePwd">
          <Input v-model="updatePwdForm.rePwd" type="password" :placeholder="langMap.inputNewPwdAgain[lang]" ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="cancel()">{{ langMap.cancel[lang] }}</Button>
        <Button type="primary" size="large" @click="ok()">{{ langMap.confirm[lang] }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import './user.less'
import { mapActions, mapState } from 'vuex'
import api from "../../../../api";
import langMap from '@/utils/language'
import { getTenantInfo } from '@/libs/util'
var md5 = require('js-md5');
export default {
  name: 'User',
  props: {
    userAvator: {
      type: String,
      default: ''
    }
  },
  data() {
    const currentLang = this.$store.state.app.language;
    // 验证新密码是否符合规则
    const validateNewPwd = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error(this.langMap.inputNewPwd[this.lang]));
      } else {
        // 检查密码长度
        if (value.length < 8) {
          callback(new Error(this.langMap.minEightChar[this.lang]));
          return;
        }

        // 检查是否包含至少一个英文字母
        if (!/[a-zA-Z]/.test(value)) {
          callback(new Error(this.langMap.minOneLetter[this.lang]));
          return;
        }

        // 检查是否包含超过3位的连续数字序列（正序和倒序）
        if (this.checkConsecutiveDigits(value)) {
          callback(new Error(this.langMap.maxThreeConsecutive[this.lang]));
          return;
        }

        // 检查是否包含超过4位相同的相邻字符
        if (this.checkRepeatedChars(value)) {
          callback(new Error(this.langMap.maxFourRepeated[this.lang]));
          return;
        }

        // 如果重复密码已经填写，再次验证
        if (this.updatePwdForm.rePwd !== '') {
          this.$refs.updatePwdForm.validateField('rePwd');
        }
        callback();
      }
    };

    // 验证重复密码是否一致
    const validateRePwd = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error(this.langMap.inputNewPwdAgain[this.lang]));
      } else if (value !== this.updatePwdForm.newPwd) {
        callback(new Error(this.langMap.pwdNotMatch[this.lang]));
      } else {
        callback();
      }
    };

    return {
      langMap:langMap,
      updatePwdModel:false,
      tenantInfo: null,
      updatePwdForm:{
        oldPwd:null,
        newPwd:null,
        rePwd:null,
      },
      passwordValidate: {
        oldPwd: [
          { required: true, message: langMap.inputOldPwd[currentLang], trigger: 'blur' }
        ],
        newPwd: [
          { max: 15, message: langMap.maxFifteenChar[currentLang], trigger: 'blur' },
          { required: true, validator: validateNewPwd, trigger: 'blur' }
        ],
        rePwd: [
          { required: true, validator: validateRePwd, trigger: 'blur' }
        ]
      },
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language
    })
  },
  methods: {
    logout () {
      this.closeAllWebSocketConnections()
      this.$store.commit('logOut');
      this.$router.push({
        name: 'login'
      })
    },
    closeAllWebSocketConnections () {
      // 关闭由LongRpc创建的WebSocket连接
      if (window._globalWebsockets && Array.isArray(window._globalWebsockets)) {
        window._globalWebsockets.forEach(ws => {
          try {
            if (ws && typeof ws.close === 'function') {
              ws.close();
            }
          } catch (err) {
            console.error('关闭WebSocket连接失败:', err);
          }
        });
        // 清空连接数组
        window._globalWebsockets = [];
      }
    },
    message () {

    },
    ok () {
      this.$refs["updatePwdForm"].validate((valid) => {
        if (valid) {
          var newJson={
            oldPwd:md5(this.updatePwdForm.oldPwd),
            newPwd:md5(this.updatePwdForm.newPwd)
          }
          this.$Spin.show();
          api.postData("system-server/user/updatePwd",newJson,this).then((res)=>{
            this.$Spin.hide();
            if(res.state==0){
              this.$Notice.error({
                title: this.langMap.tip[this.lang],
                desc:res.msg,
              });
            }else{
              this.$Notice.success({
                title: this.langMap.tip[this.lang],
                desc: res.message
              });
              this.$refs.updatePwdForm.resetFields();
              this.updatePwdModel = false;
            }
          })
        }
      });
    },
    cancel () {
      this.updatePwdModel = false;
    },
    updatePwd(){
      this.updatePwdForm = {
        oldPwd:null,
        newPwd:null,
        rePwd:null,
      },
        this.updatePwdModel = true;
    },
    handleClick (name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'message': this.message()
          break
        case 'updatePwd': this.updatePwd()
          break
        case 'refreshCache': this.refreshCache()
          break
        default:
      }
    },
    refreshCache() {
      this.$Notice.info({
        title: this.langMap.tip[this.lang],
        desc: this.langMap.refreshingCache[this.lang]
      });
      // 清除浏览器缓存并强制重新加载
      window.location.reload(true);
    },
    // 检查密码是否包含超过3位的连续数字序列（正序和倒序）
    checkConsecutiveDigits(password) {
      for (let i = 0; i < password.length - 3; i++) {
        const segment = password.substring(i, i + 4);
        if (/^\d{4}$/.test(segment)) {
          // 检查正序连续
          let isConsecutiveAsc = true;
          for (let j = 0; j < segment.length - 1; j++) {
            if (parseInt(segment[j]) + 1 !== parseInt(segment[j + 1])) {
              isConsecutiveAsc = false;
              break;
            }
          }

          // 检查倒序连续
          let isConsecutiveDesc = true;
          for (let j = 0; j < segment.length - 1; j++) {
            if (parseInt(segment[j]) - 1 !== parseInt(segment[j + 1])) {
              isConsecutiveDesc = false;
              break;
            }
          }

          if (isConsecutiveAsc || isConsecutiveDesc) {
            return true; // 找到超过3位的连续数字序列（正序或倒序）
          }
        }
      }
      return false; // 没有找到超过3位的连续数字序列
    },
    // 检查密码是否包含超过4位相同的相邻字符
    checkRepeatedChars(password) {
      for (let i = 0; i < password.length - 4; i++) {
        const char = password[i];
        let count = 1;

        for (let j = i + 1; j < password.length; j++) {
          if (password[j] === char) {
            count++;
            if (count > 4) {
              return true; // 找到超过4位相同的相邻字符
            }
          } else {
            break; // 遇到不同字符，结束当前检查
          }
        }
      }
      return false; // 没有找到超过4位相同的相邻字符
    },


  },
  created () {
    this.tenantInfo = getTenantInfo();
  }
}
</script>
<style scoped>
  .demo-badge{
    width: 42px;
    height: 42px;
    background: #eee;
    border-radius: 6px;
    display: inline-block;
  }
</style>
